import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {
		ZakaznikId: null as number | null,
		ZakaznikIdText: null as string | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.ZAKAZNIK_ID_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
